const requests = {
  'nav.requests': 'Requests',
  'requests.title': 'Requests',
  'requests.new': 'New request',
  'requests.type.URLAUB': 'Vacation',
  'requests.type.FZT': 'Comp. time',
  'requests.form.type': 'Request type',
  'requests.form.titleFzt': 'New comp. time request',
  'requests.form.substituteMandatoryHintFzt': 'Your team requires a substitute from the team for comp. time requests.',
  'requests.col.type': 'Type',
  'requests.my.title': 'My requests',
  'requests.team.title': 'Requests of my team',
  'requests.fzt.quota': 'Comp. time allowance {year}',
  'requests.fzt.total': 'Total',
  'requests.fzt.used': 'Taken / requested',
  'requests.fzt.available': 'Available',
};

export default requests;
